export default "__VITE_ASSET__6cb4bf41__"